import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-pattern-modal',
    templateUrl: './pattern-modal.component.html',
    styleUrls: ['./pattern-modal.component.scss'],
    standalone: false
})
export class PatternModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
